import gmail from "./icons/gmail.png";
import linkedIn from "./icons/icons8-linkedin-50.png";
import youtube from "./icons/icons8-play-button-50.png";
import github from "./icons/icons8-github-50.png";

const socialMediaData = [
	{ "medium": "e-mail", "link": "milesoluku@gmail.com", "img": gmail },
	{
		"medium": "LinkedIn",
		"link": "milesoluku@gmail.com",
		"img": linkedIn
	},
	{
		"medium": "Facebook",
		"link": "milesoluku@gmail.com",
		"img": "#"
	},
	{
		"medium": "Youtube",
		"link": "milesoluku@gmail.com",
		"img": youtube
	},
	{
		"medium": "Github",
		"link": "milesoluku@gmail.com",
		"img": github
	}
]

export default socialMediaData;